import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Header from '../../../components/Header'
import { useLocation, useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { addBom, editBom, getBom, getcategoryBom, getproductBom, getstoreBom, getsubcategoryBom } from '../../../redux/slice/bom.slice';
import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from '@mui/icons-material/Delete';

const validationSchemas =
    Yup.object({
        BOMName: Yup.string().required("BOM Name is required"),
        systemSize: Yup.string().required("System Size is required"),
        Date: Yup.date().required("Date is required"),
        TypesOfProject: Yup.string().required("Types Of Project is required"),
        BomDetails: Yup.array().of(Yup.object({
            bomcategory: Yup.string().required("Bom Category is required"),
            bomsubcategory: Yup.string().required("Bom Subcategory is required"),
            bomproduct: Yup.string().required("Bom Product is required"),
            bomdescription: Yup.string().required("Bom Description is required"),
        })),
        SystemSize1: Yup.number().required("System Size 1 is required"),
        SystemSize2: Yup.number().required("System Size 2 is required"),
        SystemSize3: Yup.number().required("System Size 3 is required"),
        SystemSize5: Yup.number().required("System Size 5 is required"),
        SystemSize6: Yup.number().required("System Size 6 is required"),
        Remarks1: Yup.string().required("Remarks 1 is required"),
        Remarks2: Yup.string().required("Remarks 2 is required"),
        Remarks3: Yup.string().required("Remarks 3 is required"),
        Remarks4: Yup.string().required("Remarks 4 is required"),
        Remarks5: Yup.string().required("Remarks 5 is required"),
        Remarks6: Yup.string().required("Remarks 6 is required"),
        unitprice1: Yup.number().required("Unit Price 1 is required"),
        unitprice2: Yup.number().required("Unit Price 2 is required"),
        unitprice3: Yup.number().required("Unit Price 3 is required"),
        unitprice4: Yup.number().required("Unit Price 4 is required"),
        unitprice5: Yup.number().required("Unit Price 5 is required"),
        unitprice6: Yup.number().required("Unit Price 6 is required"),
        subcidy: Yup.number().required("Subcidy is required"),
    });

const initialValues = {
    BOMName: '',
    bomsuggestion: null,
    systemSize: '',
    Date: '',
    TypesOfProject: '',
    BomDetails: [{
        bomcategory: '',
        bomsubcategory: '',
        bomproduct: '',
        bomdescription: '',
        bomqty: '',
        bomlastprice: '',
        bomamount: '',
    }],
    SystemSize1: '1',
    SystemSize2: '1',
    SystemSize3: '1',
    SystemSize5: '1',
    SystemSize6: '1',
    Remarks1: '',
    Remarks2: '',
    Remarks3: '',
    Remarks4: '',
    Remarks5: '',
    Remarks6: '',
    unitprice1: '2000',
    unitprice2: '0',
    unitprice3: '0',
    unitprice4: '5000',
    unitprice5: '0',
    unitprice6: '0',
    Amount1: '',
    Amount2: '',
    Amount3: '',
    Amount4: '',
    Amount5: '',
    Amount6: '',
    GST: '',
    subcidy: '',
    TotalAmount: '',
    PriceAfterSubcidy: '',
    Total: '',
};

const AddBillofMaterial = () => {
    const { state } = useLocation();
    const bomData = state;
    const id = bomData?._id;
    const getUserId = localStorage.getItem('id');
    const theme = useTheme();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [bomdata, setbomdata] = useState(initialValues.BomDetails)
    const [filteredProducts, setFilteredProducts] = useState([]);
    const store = useSelector(state => state.bom.store)
    const categories = useSelector(state => state.bom.category);
    const subcategories = useSelector(state => state.bom.subCategory);
    const productData = useSelector(state => state.bom.products)
    const bom = useSelector(state => state.bom.Bom)
    const isMobile = useMediaQuery('(max-width:500px)');


    useEffect(() => {
        dispatch(getBom())
        dispatch(getcategoryBom());
        dispatch(getsubcategoryBom());
        dispatch(getproductBom());
        dispatch(getstoreBom());
    }, []);


    useEffect(() => {
        if (id) {
            setValues(bomData);
            setbomdata(bomData.BomDetails);
            setIsNewBom(false);
            const newFilteredProducts = bomData.BomDetails?.map(detail => {
                return productData?.filter(product =>
                    product.subCategoryData?.some(sub => sub._id === detail.bomsubcategory)
                ) || [];
            });
            setFilteredProducts(newFilteredProducts);
        } else {
            dispatch(getBom())
            resetForm();
            setIsNewBom(true);
        }
    }, [id, bomData])

    useEffect(() => {
        if (id) {
            setValues(bomData);
            const newFilteredProducts = bomData.BomDetails?.map(detail => {
                return productData?.filter(product =>
                    product.subCategoryData?.some(sub => sub._id === detail.bomsubcategory)
                ) || [];
            });
            setFilteredProducts(newFilteredProducts);
        }
    }, [id, bomData, productData])


    const handleCategoryChange = (index, value) => {
        setFieldValue(`BomDetails[${index}].bomcategory`, value);
        setFieldValue(`BomDetails[${index}].bomsubcategory`, "");
        setFieldValue(`BomDetails[${index}].bomproduct`, "");

        const productsForCategory = productData?.filter(product => product.mainCategoryData?.[0]?._id === value);
        setFilteredProducts(prev => {
            const newFilteredProducts = [...prev];
            newFilteredProducts[index] = productsForCategory || [];
            return newFilteredProducts;
        });
    };

    const handleSubCategoryChange = (index, value) => {
        setFieldValue(`BomDetails[${index}].bomsubcategory`, value);
        const productsForSubcategory = productData?.filter(product => product.subCategoryData?.[0]?._id === value);
        setFilteredProducts(prev => {
            const newFilteredProducts = [...prev];
            newFilteredProducts[index] = productsForSubcategory || [];
            return newFilteredProducts;
        });
    };

    const handleProductChange = (index, value) => {
        setFieldValue(`BomDetails[${index}].bomproduct`, value);
        const product = productData?.find(product => product._id === value);
        if (product) {
            setFieldValue(`BomDetails[${index}].bomdescription`, product.Desacription);
            let lastRecieveUnitPrice = null;
            store.forEach(storeItem => {
                const matchingItem = storeItem.multipleQty.find(item => item.productName === value);
                if (matchingItem) {
                    lastRecieveUnitPrice = matchingItem.recieveunitPrice;
                }
            });
            if (lastRecieveUnitPrice !== null) {
                setFieldValue(`BomDetails[${index}].bomlastprice`, lastRecieveUnitPrice);
            }
        }
    }

    const [isNewBom, setIsNewBom] = React.useState(true);

    const handleSubmit = (values) => {
        try {
            validationSchemas.validate(values, { abortEarly: false });
            const submissionValues = {
                ...values,
                userId: getUserId,
                bomsuggestion: values.bomsuggestion || null,
                BomDetails: values.BomDetails.map(detail => ({
                    bomcategory: detail.bomcategory,
                    bomsubcategory: detail.bomsubcategory,
                    bomproduct: detail.bomproduct,
                    bomdescription: detail.bomdescription,
                    bomqty: detail.bomqty,
                    bomlastprice: detail.bomlastprice,
                    bomamount: detail.bomqty * detail.bomlastprice,
                })),
                SystemSize1: values.SystemSize1,
                SystemSize2: values.SystemSize2,
                SystemSize3: values.SystemSize3,
                SystemSize5: values.SystemSize5,
                SystemSize6: values.SystemSize6,
                unitprice1: values.unitprice1 || 2000,
                unitprice2: values.unitprice2 || 0,
                unitprice3: values.unitprice3 || 0,
                unitprice4: values.unitprice4 || 5000,
                unitprice5: values.unitprice5 || 0,
                unitprice6: values.unitprice6 || 0,
                Amount1: ((values.SystemSize1) * (values.unitprice1 || 2000)).toFixed(2),
                Amount2: ((values.SystemSize2) * (values.unitprice2 || 0)).toFixed(2),
                Amount3: ((values.SystemSize3) * (values.unitprice3 || 0)).toFixed(2),
                Amount4: ((values.systemSize) * (values.unitprice4 || 5000)).toFixed(2),
                Amount5: ((values.SystemSize5) * (values.unitprice5 || 0)).toFixed(2),
                Amount6: ((values.SystemSize6) * (values.unitprice6 || 0)).toFixed(2),
                subcidy: values.subcidy,

                Total: Number((values.SystemSize1) * (values.unitprice1)) + Number((values.SystemSize2) * (values.unitprice2)) + Number((values.SystemSize3) * (values.unitprice3)) + Number((values.systemSize) * (values.unitprice4)) + Number((values.SystemSize5) * (values.unitprice5)) + Number((values.SystemSize6) * (values.unitprice6)),

                GST: ((Number((values.SystemSize1) * (values.unitprice1)) + Number((values.SystemSize2) * (values.unitprice2)) + Number((values.SystemSize3) * (values.unitprice3)) + Number((values.systemSize) * (values.unitprice4)) + Number((values.SystemSize5) * (values.unitprice5)) + Number((values.SystemSize6) * (values.unitprice6))) * 13.8) / 100,

                TotalAmount: Number((values.SystemSize1) * (values.unitprice1)) + Number((values.SystemSize2) * (values.unitprice2)) + Number((values.SystemSize3) * (values.unitprice3)) + Number((values.systemSize) * (values.unitprice4)) + Number((values.SystemSize5) * (values.unitprice5)) + Number((values.SystemSize6) * (values.unitprice6)) + ((Number((values.SystemSize1) * (values.unitprice1)) + Number((values.SystemSize2) * (values.unitprice2)) + Number((values.SystemSize3) * (values.unitprice3)) + Number((values.systemSize) * (values.unitprice4)) + Number((values.SystemSize5) * (values.unitprice5)) + Number((values.SystemSize6) * (values.unitprice6))) * 13.8) / 100,


                PriceAfterSubcidy: Number((values.SystemSize1) * (values.unitprice1)) + Number((values.SystemSize2) * (values.unitprice2)) + Number((values.SystemSize3) * (values.unitprice3)) + Number((values.systemSize) * (values.unitprice4)) + Number((values.SystemSize5) * (values.unitprice5)) + Number((values.SystemSize6) * (values.unitprice6)) + ((Number((values.SystemSize1) * (values.unitprice1)) + Number((values.SystemSize2) * (values.unitprice2)) + Number((values.SystemSize3) * (values.unitprice3)) + Number((values.systemSize) * (values.unitprice4)) + Number((values.SystemSize5) * (values.unitprice5)) + Number((values.SystemSize6) * (values.unitprice6))) * 13.8) / 100 - values.subcidy,
            };
            if (id) {
                dispatch(editBom({ _id: id, ...submissionValues }));
            } else {
                dispatch(addBom({ ...submissionValues })).then(response => {
                    navigate(`/admin/add-sales`, { state: { id: response.payload._id } });
                });
            }
            setIsNewBom(true);
        } catch (validationErrors) {
            console.log("Form validation errors:", validationErrors);
            alert("Please fill in all required fields before submitting.");
        }
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchemas,
        onSubmit: handleSubmit,
    });

    const { handleBlur, handleChange, values, touched, errors, setFieldValue, setValues, resetForm } = formik

    const handleAddBom = () => {
        const newBom = {
            bomcategory: '',
            bomsubcategory: '',
            bomproduct: '',
            bomdescription: '',
            bomqty: '',
            bomlastprice: '',
            bomamount: '',
        };

        setbomdata([...bomdata, newBom]);
        setFieldValue('BomDetails', [...values.BomDetails, newBom]);
    }

    const handleAddBOM = (index) => {
        const oldBomDetails = [...values.BomDetails];

        const newBom = {
            bomcategory: '',
            bomsubcategory: '',
            bomproduct: '',
            bomdescription: '',
            bomqty: '',
            bomlastprice: '',
            bomamount: '',
        };

        oldBomDetails.splice(index + 1, 0, newBom);
        const productsForCategory = productData;
        const filter = [...filteredProducts];
        filter.splice(index + 1, 0, productData)
        setFilteredProducts(filter);
        setbomdata(oldBomDetails);
        setFieldValue('BomDetails', oldBomDetails);

        formik.setTouched({
            BomDetails: oldBomDetails.map((_, i) => ({
                bomcategory: i === index + 1 ? false : touched.BomDetails?.[i]?.bomcategory,
                bomsubcategory: i === index + 1 ? false : touched.BomDetails?.[i]?.bomsubcategory,
                bomproduct: i === index + 1 ? false : touched.BomDetails?.[i]?.bomproduct,
                bomdescription: i === index + 1 ? false : touched.BomDetails?.[i]?.bomdescription,
                bomqty: i === index + 1 ? false : touched.BomDetails?.[i]?.bomqty,
                bomlastprice: i === index + 1 ? false : touched.BomDetails?.[i]?.bomlastprice,
                bomamount: i === index + 1 ? false : touched.BomDetails?.[i]?.bomamount,
            })),
        });
    }

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);

    const handleOpenConfirmDialog = (index) => {
        setDeleteIndex(index);
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
        setDeleteIndex(null);
    };

    const handleConfirmDelete = () => {
        const updatedBomDetails = bomdata.filter((_, i) => i !== deleteIndex);
        setbomdata(updatedBomDetails);
        setFieldValue('BomDetails', updatedBomDetails);
        handleCloseConfirmDialog();
    };

    const handleBomSuggestionChange = (event) => {
        const selectedBomId = event.target.value;

        if (selectedBomId === '') {
            setValues({
                ...initialValues,
                bomsuggestion: null
            });
            setbomdata(initialValues.BomDetails);
            setFilteredProducts([]);
            return;
        }

        const selectedBom = bom.find(item => item._id === selectedBomId);

        if (selectedBom) {
            setValues({
                ...values,
                bomsuggestion: selectedBomId,
                Date: selectedBom.Date,
                TypesOfProject: selectedBom.TypesOfProject,
                systemSize: selectedBom.systemSize,
                BomDetails: selectedBom.BomDetails.map(detail => ({
                    bomcategory: detail.bomcategory,
                    bomsubcategory: detail.bomsubcategory,
                    bomproduct: detail.bomproduct,
                    bomdescription: detail.bomdescription,
                    bomqty: detail.bomqty,
                    bomlastprice: detail.bomlastprice,
                    bomamount: detail.bomamount,
                })),
                Remarks1: selectedBom.Remarks1,
                Remarks2: selectedBom.Remarks2,
                Remarks3: selectedBom.Remarks3,
                Remarks4: selectedBom.Remarks4,
                Remarks5: selectedBom.Remarks5,
                Remarks6: selectedBom.Remarks6,
                SystemSize1: selectedBom.SystemSize1,
                SystemSize2: selectedBom.SystemSize2,
                SystemSize3: selectedBom.SystemSize3,
                SystemSize5: selectedBom.SystemSize5,
                SystemSize6: selectedBom.SystemSize6,
                unitprice1: selectedBom.unitprice1,
                unitprice2: selectedBom.unitprice2,
                unitprice3: selectedBom.unitprice3,
                unitprice4: selectedBom.unitprice4,
                unitprice5: selectedBom.unitprice5,
                unitprice6: selectedBom.unitprice6,
                subcidy: selectedBom.subcidy || '',
            });

            setbomdata(selectedBom.BomDetails);

            const newFilteredProducts = selectedBom.BomDetails.map(detail => {
                return productData?.filter(product =>
                    product.subCategoryData?.some(sub => sub._id === detail.bomsubcategory)
                ) || [];
            });
            setFilteredProducts(newFilteredProducts);
        }
    };
    return (
        <Box m="2px">
            {id ? (
                <Header
                    title="UPDATE BILL OF MATERIAL"
                    subtitle="Update Your Bill of Material Detail"
                />
            ) : (
                <Header
                    title="ADD BILL OF MATERIAL"
                    subtitle="Manage Your Bill of Material Detail"
                />
            )}
            <form onSubmit={handleSubmit} >
                <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>

                    <Box
                        display="grid"
                        gap="30px"
                        gridTemplateColumns="repeat(5, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                        }}
                    >
                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="BOM Name:"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.BOMName}
                                name="BOMName"
                                error={!!touched.BOMName && !!errors.BOMName}
                                helperText={touched.BOMName && errors.BOMName}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <TextField
                            fullWidth
                            margin="dense"
                            label="BOM suggestion:"
                            select
                            variant="filled"
                            onBlur={handleBlur}
                            name='bomsuggestion'
                            onChange={handleBomSuggestionChange}
                            value={values.bomsuggestion || ''}
                            error={!!touched.bomsuggestion && !!errors.bomsuggestion}
                            helperText={touched.bomsuggestion && errors.bomsuggestion}
                            InputLabelProps={{
                                style: {
                                    color: theme.palette.text.primary
                                }
                            }}
                        >
                            {Array.isArray(bom) && bom?.map((bom) => (
                                <MenuItem key={bom._id} value={bom._id}>
                                    {bom.BOMName}
                                </MenuItem>
                            ))}
                        </TextField>
                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="System Size:"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.systemSize}
                                name="systemSize"
                                error={!!touched.systemSize && !!errors.systemSize}
                                helperText={touched.systemSize && errors.systemSize}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="date"
                                label="Date:"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.Date}
                                name="Date"
                                error={!!touched.Date && !!errors.Date}
                                helperText={touched.Date && errors.Date}
                                InputLabelProps={{
                                    shrink: true,
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <TextField
                            margin="dense"
                            id="TypesOfProject"
                            name="TypesOfProject"
                            label="Types Of Project :"
                            select
                            fullWidth
                            variant="filled"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.TypesOfProject}
                            error={touched.TypesOfProject && Boolean(errors.TypesOfProject)}
                            helperText={touched.TypesOfProject && errors.TypesOfProject}
                            InputLabelProps={{
                                style: {
                                    color: theme.palette.text.primary
                                }
                            }}
                            sx={{ width: '100%' }}
                        >
                            <MenuItem value="Residential Individual">Residential Individual</MenuItem>
                            <MenuItem value="Residential Comman Meter">Residential Comman Meter</MenuItem>
                            <MenuItem value="Commercial with Large BOM">Commercial with Large BOM</MenuItem>
                            <MenuItem value="Commercial with Small BOM">Commercial with Small BOM</MenuItem>
                        </TextField>
                    </Box>
                    <Box sx={{ overflowX: "auto", width: "100%" }}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ width: "70px", fontSize: "14px" }} > Sr No</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Category</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Sub Category</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Product Name</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Description</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Qty</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>Last PO Price</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>Amount</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        bomdata && bomdata.map((bom, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ width: 50 }}>
                                                    {index + 1}
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }} >
                                                    <TextField
                                                        margin="dense"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "190px",
                                                                sm: "190px",
                                                                md: "230px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`BomDetails.${index}.bomcategory`}
                                                        onChange={e => handleCategoryChange(index, e.target.value)}
                                                        value={values.BomDetails?.[index]?.bomcategory || ''}
                                                        error={!!touched.BomDetails?.[index]?.bomcategory && !!errors.BomDetails?.[index]?.bomcategory}
                                                        helperText={touched.BomDetails?.[index]?.bomcategory && errors.BomDetails?.[index]?.bomcategory}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    >
                                                        {categories?.map((category) => (
                                                            <MenuItem key={category._id} value={category._id}>
                                                                {category.categoryName}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "190px",
                                                                sm: "190px",
                                                                md: "230px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`BomDetails.${index}.bomsubcategory`}
                                                        onChange={e => handleSubCategoryChange(index, e.target.value)}
                                                        value={values.BomDetails?.[index]?.bomsubcategory || ''}
                                                        error={!!touched.BomDetails?.[index]?.bomsubcategory && !!errors.BomDetails?.[index]?.bomsubcategory}
                                                        helperText={touched.BomDetails?.[index]?.bomsubcategory && errors.BomDetails?.[index]?.bomsubcategory}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    >
                                                        {subcategories?.filter(subcategory => subcategory.categoryData?.[0]?._id === values.BomDetails[index].bomcategory)
                                                            .map((subcategory) => (
                                                                <MenuItem key={subcategory._id} value={subcategory._id}>
                                                                    {subcategory.subCategoryName}
                                                                </MenuItem>
                                                            ))}
                                                    </TextField>
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "190px",
                                                                sm: "190px",
                                                                md: "230px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`BomDetails.${index}.bomproduct`}
                                                        onChange={e => handleProductChange(index, e.target.value)}
                                                        value={values.BomDetails?.[index]?.bomproduct || ''}
                                                        error={!!touched.BomDetails?.[index]?.bomproduct && !!errors.BomDetails?.[index]?.bomproduct}
                                                        helperText={touched.BomDetails?.[index]?.bomproduct && errors.BomDetails?.[index]?.bomproduct}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    >
                                                        {filteredProducts[index]?.map(product => (
                                                            <MenuItem key={product._id} value={product._id}>
                                                                {product.productName}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        sx={{
                                                            width: {
                                                                xs: "190px",
                                                                sm: "190px",
                                                                md: "230px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        onChange={e => setFieldValue(`BomDetails[${index}].bomdescription`, e.target.value)}
                                                        value={values.BomDetails?.[index]?.bomdescription || ''}
                                                        name={`BomDetails.${index}.bomdescription`}
                                                        error={!!touched.BomDetails?.[index]?.bomdescription && !!errors.BomDetails?.[index]?.bomdescription}
                                                        helperText={touched.BomDetails?.[index]?.bomdescription && errors.BomDetails?.[index]?.bomdescription}

                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        sx={{
                                                            width: {
                                                                xs: "80px",
                                                                sm: "80px",
                                                                md: "80px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {
                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.BomDetails?.[index]?.bomqty || ''}
                                                        name={`BomDetails.${index}.bomqty`}
                                                        error={!!touched.BomDetails?.[index]?.bomqty && !!errors.BomDetails?.[index]?.bomqty}
                                                        helperText={touched.BomDetails?.[index]?.bomqty && errors.BomDetails?.[index]?.bomqty}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        sx={{
                                                            width: {
                                                                xs: "80px",
                                                                sm: "80px",
                                                                md: "80px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {
                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                            marginTop: values.BomDetails?.[index]?.bomlastprice ? "22px" : "0px",
                                                        }}
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.BomDetails?.[index]?.bomlastprice || ''}
                                                        name={`BomDetails.${index}.bomlastprice`}
                                                        error={!!touched.BomDetails?.[index]?.bomlastprice && !!errors.BomDetails?.[index]?.bomlastprice}
                                                        helperText={touched.BomDetails?.[index]?.bomlastprice && errors.BomDetails?.[index]?.bomlastprice}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                    {values.BomDetails?.[index]?.bomproduct && (
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                color: theme.palette.text.secondary,
                                                                fontSize: '0.7rem',
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                            {(() => {
                                                                const productId = values.BomDetails[index].bomproduct;
                                                                let lastPrice = null;

                                                                store?.forEach(storeItem => {
                                                                    const matchingItem = storeItem.multipleQty.find(
                                                                        item => item.productName === productId
                                                                    );
                                                                    if (matchingItem) {
                                                                        lastPrice = matchingItem.recieveunitPrice;
                                                                    }
                                                                });

                                                                return lastPrice ? `Last PO: ${lastPrice}` : 'No previous PO';
                                                            })()}
                                                        </Typography>
                                                    )}
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        sx={{
                                                            width: {
                                                                xs: "80px",
                                                                sm: "80px",
                                                                md: "80px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {
                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        value={(values.BomDetails?.[index]?.bomqty && values.BomDetails?.[index]?.bomlastprice) ? (values.BomDetails?.[index]?.bomqty * values.BomDetails?.[index]?.bomlastprice).toFixed(2) : ''}
                                                        name={`BomDetails.${index}.bomamount`}
                                                        error={!!touched.BomDetails?.[index]?.bomamount && !!errors.BomDetails?.[index]?.bomamount}
                                                        helperText={touched.BomDetails?.[index]?.bomamount && errors.BomDetails?.[index]?.bomamount}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <Stack spacing={2} direction="row">
                                                        <Button
                                                            variant="contained"
                                                            color="success"
                                                            onClick={() => handleAddBOM(index)}
                                                            sx={{
                                                                width: "35px",
                                                                height: "35px",
                                                                minWidth: "20px",
                                                                padding: "0",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <AddIcon sx={{ fontSize: "16px" }} />
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="error"
                                                            onClick={() => handleOpenConfirmDialog(index)}
                                                            sx={{
                                                                width: "35px",
                                                                height: "35px",
                                                                minWidth: "20px",
                                                                padding: "0",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <DeleteIcon sx={{ fontSize: "16px" }} />
                                                        </Button>
                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box display="flex" justifyContent="flex-end" m={1}>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={handleAddBom}
                        >
                            Add Bom Details
                        </Button>
                    </Box>

                    <Dialog
                        open={openConfirmDialog}
                        onClose={handleCloseConfirmDialog}
                    >
                        <DialogTitle>Confirm Deletion</DialogTitle>
                        <DialogContent>
                            Are you sure you want to delete this item?
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseConfirmDialog} sx={{ color: theme.palette.text.primary }}>
                                Cancel
                            </Button>
                            <Button onClick={handleConfirmDelete} color="error">
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Box>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ border: 'none', color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}></TableCell>
                                    <TableCell sx={{ border: 'none', color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Remarks</TableCell>
                                    <TableCell sx={{ border: 'none', color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>System Size</TableCell>
                                    <TableCell sx={{ border: 'none', color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Unit Price</TableCell>
                                    <TableCell sx={{ border: 'none', color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                <TableRow>
                                    <TableCell sx={{ border: 'none', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        Dealer Commission in KW
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Remarks :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.Remarks1 || ''}
                                                name="Remarks1"
                                                error={!!touched.Remarks1 && !!errors.Remarks1}
                                                helperText={touched.Remarks1 && errors.Remarks1}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="System Size :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.SystemSize1}
                                                name="SystemSize1"
                                                error={!!touched.SystemSize1 && !!errors.SystemSize1}
                                                helperText={touched.SystemSize1 && errors.SystemSize1}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Unit Price :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.unitprice1}
                                                name="unitprice1"
                                                error={!!touched.unitprice1 && !!errors.unitprice1}
                                                helperText={touched.unitprice1 && errors.unitprice1}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Amount :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={(values.SystemSize1) * (values.unitprice1 || 2000)}
                                                name="Amount1"
                                                error={!!touched.Amount1 && !!errors.Amount1}
                                                helperText={touched.Amount1 && errors.Amount1}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell sx={{ border: 'none', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        Interest
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Remarks :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.Remarks2 || ''}
                                                name="Remarks2"
                                                error={!!touched.Remarks2 && !!errors.Remarks2}
                                                helperText={touched.Remarks2 && errors.Remarks2}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="System Size :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.SystemSize2}
                                                name="SystemSize2"
                                                error={!!touched.SystemSize2 && !!errors.SystemSize2}
                                                helperText={touched.SystemSize2 && errors.SystemSize2}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Unit Price :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const parsedValue = value ? parseFloat(value) : 0;
                                                    setFieldValue('unitprice2', parsedValue);
                                                }}
                                                value={values.unitprice2 || '0'}
                                                name="unitprice2"
                                                error={!!touched.unitprice2 && !!errors.unitprice2}
                                                helperText={touched.unitprice2 && errors.unitprice2}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Amount :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={(values.SystemSize2) * (values.unitprice2 || 0)}
                                                name="Amount2"
                                                error={!!touched.Amount2 && !!errors.Amount2}
                                                helperText={touched.Amount2 && errors.Amount2}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell sx={{ border: 'none', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        Service & Maintenance
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Remarks :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.Remarks3 || ''}
                                                name="Remarks3"
                                                error={!!touched.Remarks3 && !!errors.Remarks3}
                                                helperText={touched.Remarks3 && errors.Remarks3}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="System Size :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.SystemSize3}
                                                name="SystemSize3"
                                                error={!!touched.SystemSize3 && !!errors.SystemSize3}
                                                helperText={touched.SystemSize3 && errors.SystemSize3}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Unit Price :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const parsedValue = value ? parseFloat(value) : 0;
                                                    setFieldValue('unitprice3', parsedValue);
                                                }}
                                                value={values.unitprice3 || '0'}
                                                name="unitprice3"
                                                error={!!touched.unitprice3 && !!errors.unitprice3}
                                                helperText={touched.unitprice3 && errors.unitprice3}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Amount :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={(values.SystemSize3) * (values.unitprice3 || 0)}
                                                name="Amount3"
                                                error={!!touched.Amount3 && !!errors.Amount3}
                                                helperText={touched.Amount3 && errors.Amount3}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell sx={{ border: 'none', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        Profit in KW
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Remarks :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.Remarks4 || ''}
                                                name="Remarks4"
                                                error={!!touched.Remarks4 && !!errors.Remarks4}
                                                helperText={touched.Remarks4 && errors.Remarks4}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="System Size :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.systemSize}
                                                name="systemSize"
                                                error={!!touched.systemSize && !!errors.systemSize}
                                                helperText={touched.systemSize && errors.systemSize}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Unit Price :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const parsedValue = value ? parseFloat(value) : 0;
                                                    setFieldValue('unitprice4', parsedValue);
                                                    if (parsedValue === 0) {
                                                        setFieldValue('unitprice4Error', true);
                                                    } else {
                                                        setFieldValue('unitprice4Error', false);
                                                    }
                                                }}
                                                value={values.unitprice4}
                                                name="unitprice4"
                                                error={!!touched.unitprice4 && !!errors.unitprice4 || values.unitprice4Error}
                                                helperText={values.unitprice4Error ? 'Unit price cannot be 0' : (touched.unitprice4 && errors.unitprice4)}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Amount :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={((values.systemSize) * (values.unitprice4 || 5000)).toFixed(2)}
                                                name="Amount4"
                                                error={!!touched.Amount4 && !!errors.Amount4}
                                                helperText={touched.Amount4 && errors.Amount4}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell sx={{ border: 'none', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        Net Meter, Stamp and MCB Charge
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Remarks :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.Remarks5 || ''}
                                                name="Remarks5"
                                                error={!!touched.Remarks5 && !!errors.Remarks5}
                                                helperText={touched.Remarks5 && errors.Remarks5}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="System Size :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.SystemSize5}
                                                name="SystemSize5"
                                                error={!!touched.SystemSize5 && !!errors.SystemSize5}
                                                helperText={touched.SystemSize5 && errors.SystemSize5}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Unit Price :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const parsedValue = value ? parseFloat(value) : 0;
                                                    setFieldValue('unitprice5', parsedValue);
                                                }}
                                                value={values.unitprice5}
                                                name="unitprice5"
                                                error={!!touched.unitprice5 && !!errors.unitprice5}
                                                helperText={touched.unitprice5 && errors.unitprice5}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Amount :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={(values.SystemSize5) * (values.unitprice5 || 0)}
                                                name="Amount5"
                                                error={!!touched.Amount5 && !!errors.Amount5}
                                                helperText={touched.Amount5 && errors.Amount5}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell sx={{ border: 'none', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        Super Structure and Extra Cabel Charge
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Remarks :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.Remarks6 || ''}
                                                name="Remarks6"
                                                error={!!touched.Remarks6 && !!errors.Remarks6}
                                                helperText={touched.Remarks6 && errors.Remarks6}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="System Size :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.SystemSize6}
                                                name="SystemSize6"
                                                error={!!touched.SystemSize6 && !!errors.SystemSize6}
                                                helperText={touched.SystemSize6 && errors.SystemSize6}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Unit Price :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const parsedValue = value ? parseFloat(value) : 0;
                                                    setFieldValue('unitprice6', parsedValue);
                                                }}
                                                value={values.unitprice6}
                                                name="unitprice6"
                                                error={!!touched.unitprice6 && !!errors.unitprice6}
                                                helperText={touched.unitprice6 && errors.unitprice6}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none', textAlign: 'center', color: theme.palette.text.primary, fontSize: '14px', paddingTop: 0, paddingBottom: 1 }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Amount :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={(values.SystemSize6) * (values.unitprice6 || 0)}
                                                name="Amount6"
                                                error={!!touched.Amount6 && !!errors.Amount6}
                                                helperText={touched.Amount6 && errors.Amount6}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Box>

                    <Box>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontSize: '14px' }}>Total</TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontSize: '14px' }}>GST</TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontSize: '14px' }}>TotalAmount</TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontSize: '14px' }}>Subcidy</TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontSize: '14px' }}>Price After Subcidy</TableCell>
                                    <TableCell sx={{ border: 'none' }}></TableCell>
                                    <TableCell sx={{ border: 'none' }}></TableCell>
                                    <TableCell sx={{ border: 'none' }}></TableCell>
                                    <TableCell sx={{ border: 'none' }}></TableCell>
                                    <TableCell sx={{ border: 'none' }}></TableCell>
                                    <TableCell sx={{ border: 'none' }}></TableCell>
                                    <TableCell sx={{ border: 'none' }}></TableCell>
                                    <TableCell sx={{ border: 'none' }}></TableCell>
                                    <TableCell sx={{ border: 'none' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontSize: '14px' }}>
                                        {(
                                            Number((values.SystemSize1) * (values.unitprice1)) +
                                            Number((values.SystemSize2) * (values.unitprice2)) +
                                            Number((values.SystemSize3) * (values.unitprice3)) +
                                            Number((values.systemSize) * (values.unitprice4)) +
                                            Number((values.SystemSize5) * (values.unitprice5)) +
                                            Number((values.SystemSize6) * (values.unitprice6))).toFixed(2)
                                        }
                                    </TableCell>

                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontSize: '14px' }}>
                                        {(((
                                            Number((values.SystemSize1) * (values.unitprice1)) +
                                            Number((values.SystemSize2) * (values.unitprice2)) +
                                            Number((values.SystemSize3) * (values.unitprice3)) +
                                            Number((values.systemSize) * (values.unitprice4)) +
                                            Number((values.SystemSize5) * (values.unitprice5)) +
                                            Number((values.SystemSize6) * (values.unitprice6))) * 13.8) / 100).toFixed(2)
                                        }
                                    </TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontSize: '14px' }}>
                                        {(
                                            Number((values.SystemSize1) * (values.unitprice1)) +
                                            Number((values.SystemSize2) * (values.unitprice2)) +
                                            Number((values.SystemSize3) * (values.unitprice3)) +
                                            Number((values.systemSize) * (values.unitprice4)) +
                                            Number((values.SystemSize5) * (values.unitprice5)) +
                                            Number((values.SystemSize6) * (values.unitprice6)) +
                                            ((
                                                Number((values.SystemSize1) * (values.unitprice1)) + Number((values.SystemSize2) * (values.unitprice2)) +
                                                Number((values.SystemSize3) * (values.unitprice3)) + Number((values.systemSize) * (values.unitprice4)) +
                                                Number((values.SystemSize5) * (values.unitprice5)) + Number((values.SystemSize6) * (values.unitprice6))) * 13.8) / 100).toFixed(2)
                                        }
                                    </TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Subcidy :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.subcidy}
                                                name="subcidy"
                                                error={!!touched.subcidy && !!errors.subcidy}
                                                helperText={touched.subcidy && errors.subcidy}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                        {(
                                            Number((values.SystemSize1) * (values.unitprice1)) +
                                            Number((values.SystemSize2) * (values.unitprice2)) +
                                            Number((values.SystemSize3) * (values.unitprice3)) +
                                            Number((values.systemSize) * (values.unitprice4)) +
                                            Number((values.SystemSize5) * (values.unitprice5)) +
                                            Number((values.SystemSize6) * (values.unitprice6)) +
                                            ((
                                                Number((values.SystemSize1) * (values.unitprice1)) +
                                                Number((values.SystemSize2) * (values.unitprice2)) +
                                                Number((values.SystemSize3) * (values.unitprice3)) +
                                                Number((values.systemSize) * (values.unitprice4)) +
                                                Number((values.SystemSize5) * (values.unitprice5)) +
                                                Number((values.SystemSize6) * (values.unitprice6))) * 13.8) / 100 - values.subcidy || 0).toFixed(2)
                                        }
                                    </TableCell>
                                </TableRow>
                            </TableBody>

                        </Table>
                    </Box>

                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                type="button"
                                onClick={() => handleSubmit(values)}
                            >
                                {id ? 'Update' : 'Save'}
                            </Button>
                        </Stack>
                    </FormControl>
                </Stack >
            </form >
        </Box >
    )
}

export default AddBillofMaterial
